import React from 'react';

import {
  convertLocationParamsToFetchParams,
  useProcesses,
} from 'app/process/api';
import {useAddProcessesToTeam} from 'app/teams/api';
import {AddNewTeamDocButton} from 'app/teams/components/TeamDetailPage/components/AddNewTeamDocButton';

import type {OverlayPlacementType} from 'app/general/overlays';
import type {ProcessDashboardFetchParamsType} from 'app/process/types';
import type {ProcessSerializedType, TeamSerializedType} from 'sweet-types';

type Props = {
  team: TeamSerializedType;
  buttonClass?: string;
  placement?: OverlayPlacementType;
};

export const AddNewTeamProcessButton = ({
  team,
  buttonClass,
  placement,
}: Props) => {
  const [addToTeam] = useAddProcessesToTeam();

  return (
    <AddNewTeamDocButton<ProcessSerializedType, ProcessDashboardFetchParamsType>
      team={team}
      buttonClass={buttonClass}
      placement={placement}
      contentType="proceduregroup"
      addAction={addToTeam}
      useDataHook={useProcesses}
      paramsConverter={convertLocationParamsToFetchParams}
    />
  );
};
